var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sys-register-base", {
    attrs: {
      loading: _vm.loading,
      model: _vm.model,
      title: _vm.title,
      icon: _vm.icon,
      show: _vm.dialog,
      maxWidth: "70%",
    },
    on: {
      onSave: _vm.save,
      "update:model": function ($event) {
        _vm.model = $event
      },
      "update:show": function ($event) {
        _vm.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "v-tabs",
              {
                staticClass: "mb-2",
                model: {
                  value: _vm.tab,
                  callback: function ($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab",
                },
              },
              [
                _c("v-tab", [_vm._v("Dados")]),
                _vm.model.id ? _c("v-tab", [_vm._v("Menus")]) : _vm._e(),
                _vm.model.id ? _c("v-tab", [_vm._v("Autorizações")]) : _vm._e(),
                _vm.model.id ? _c("v-tab", [_vm._v("Dashboards")]) : _vm._e(),
                _c("v-tab", [_vm._v("Recursos")]),
                _vm.model.id ? _c("v-tab", [_vm._v("Usuários")]) : _vm._e(),
              ],
              1
            ),
            _vm.tab !== 0 && _vm.model && _vm.model.name
              ? _c(
                  "v-alert",
                  {
                    staticClass: "mt-2 mb-2 text-body-2",
                    attrs: {
                      dense: "",
                      text: "",
                      color: "indigo",
                      border: "left",
                      icon: "mdi-shield-account",
                    },
                  },
                  [
                    _vm._v(" Você está configurando as opções do perfil "),
                    _c("strong", [_vm._v(_vm._s(_vm.model.name))]),
                    _vm._v(". "),
                  ]
                )
              : _vm._e(),
            _c(
              "v-tabs-items",
              {
                model: {
                  value: _vm.tab,
                  callback: function ($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab",
                },
              },
              [
                _c(
                  "v-tab-item",
                  [
                    _c(
                      "v-container",
                      { attrs: { fluid: "" } },
                      [
                        _vm.isAdminRole
                          ? _c(
                              "v-alert",
                              {
                                staticClass: "mb-4",
                                attrs: {
                                  dense: "",
                                  text: "",
                                  type: "warning",
                                  border: "left",
                                },
                              },
                              [
                                _vm._v(" Perfil de "),
                                _c("strong", [_vm._v("administrador")]),
                                _vm._v(
                                  ": os dados de identificação e permissões são fixos e não podem ser alterados. "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "v-card",
                          { staticClass: "mb-4", attrs: { outlined: "" } },
                          [
                            _c(
                              "v-card-title",
                              {
                                staticClass:
                                  "py-2 subtitle-2 grey--text text--darken-2",
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-2",
                                    attrs: {
                                      small: "",
                                      color: "grey darken-1",
                                    },
                                  },
                                  [_vm._v("mdi-card-account-details-outline")]
                                ),
                                _vm._v(" Identificação "),
                              ],
                              1
                            ),
                            _c("v-divider"),
                            _c(
                              "v-card-text",
                              [
                                _c(
                                  "v-row",
                                  { attrs: { align: "center" } },
                                  [
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "12", sm: "5" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            autofocus: "",
                                            disabled: _vm.isAdminRole,
                                            error: !!_vm.errors.name,
                                            "error-messages": _vm.errors.name,
                                            label: "Nome*",
                                            "hide-details": "auto",
                                          },
                                          model: {
                                            value: _vm.model.name,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.model, "name", $$v)
                                            },
                                            expression: "model.name",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "6", sm: "3" } },
                                      [
                                        _c("s-text-field", {
                                          attrs: {
                                            code: "",
                                            disabled: _vm.isAdminRole,
                                            "error-messages": _vm.errors.code,
                                            label: "Código",
                                            "hide-details": "auto",
                                          },
                                          model: {
                                            value: _vm.model.code,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.model, "code", $$v)
                                            },
                                            expression: "model.code",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "6", sm: "2" } },
                                      [
                                        _c("s-text-field", {
                                          attrs: {
                                            disabled: _vm.isAdminRole,
                                            "error-messages": _vm.errors.level,
                                            label: "Nível",
                                            "hide-details": "auto",
                                          },
                                          model: {
                                            value: _vm.model.level,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.model, "level", $$v)
                                            },
                                            expression: "model.level",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "12", sm: "2" } },
                                      [
                                        _c("s-switch", {
                                          attrs: {
                                            color: "purple",
                                            inset: "",
                                            disabled: _vm.isAdminRole,
                                            label: "Ativo",
                                          },
                                          model: {
                                            value: _vm.model.active,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.model, "active", $$v)
                                            },
                                            expression: "model.active",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "12" } },
                                      [
                                        _c("v-textarea", {
                                          attrs: {
                                            disabled: _vm.isAdminRole,
                                            outlined: "",
                                            name: "input-7-4",
                                            label: "Detalhes",
                                            "auto-grow": false,
                                            rows: "2",
                                            "hide-details": "",
                                          },
                                          model: {
                                            value: _vm.model.description,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.model,
                                                "description",
                                                $$v
                                              )
                                            },
                                            expression: "model.description",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-card",
                          { attrs: { outlined: "" } },
                          [
                            _c(
                              "v-card-title",
                              {
                                staticClass:
                                  "py-2 subtitle-2 grey--text text--darken-2",
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-2",
                                    attrs: {
                                      small: "",
                                      color: "grey darken-1",
                                    },
                                  },
                                  [_vm._v("mdi-key-outline")]
                                ),
                                _vm._v(" Permissões do perfil "),
                              ],
                              1
                            ),
                            _c("v-divider"),
                            _c(
                              "v-card-text",
                              { staticClass: "pt-1" },
                              [
                                _c(
                                  "v-row",
                                  _vm._l(
                                    _vm.permissionSwitches,
                                    function (perm) {
                                      return _c(
                                        "v-col",
                                        {
                                          key: perm.key,
                                          staticClass: "py-2",
                                          attrs: { cols: "12", sm: "6" },
                                        },
                                        [
                                          _c("s-switch", {
                                            staticClass: "ma-0 pa-0",
                                            attrs: {
                                              inset: "",
                                              "hide-details": "",
                                              disabled: _vm.isAdminRole,
                                              label: perm.label,
                                            },
                                            model: {
                                              value: _vm.model[perm.key],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.model,
                                                  perm.key,
                                                  $$v
                                                )
                                              },
                                              expression: "model[perm.key]",
                                            },
                                          }),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "caption grey--text text--darken-1 mt-1",
                                            },
                                            [_vm._v(_vm._s(perm.description))]
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.model.id
                  ? _c(
                      "v-tab-item",
                      [
                        _c(
                          "v-container",
                          { attrs: { fluid: "" } },
                          [
                            _vm.isAdminRole
                              ? _c(
                                  "v-alert",
                                  {
                                    attrs: {
                                      dense: "",
                                      text: "",
                                      type: "info",
                                      border: "left",
                                    },
                                  },
                                  [
                                    _vm._v(" Perfil de "),
                                    _c("strong", [_vm._v("administrador")]),
                                    _vm._v(": tem acesso a "),
                                    _c("strong", [_vm._v("todos os menus")]),
                                    _vm._v(". "),
                                  ]
                                )
                              : _c("part-role-menus", {
                                  model: {
                                    value: _vm.model.menu,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "menu", $$v)
                                    },
                                    expression: "model.menu",
                                  },
                                }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.model.id
                  ? _c(
                      "v-tab-item",
                      [
                        _c(
                          "v-container",
                          { attrs: { fluid: "" } },
                          [
                            _vm.isAdminRole
                              ? _c(
                                  "v-alert",
                                  {
                                    attrs: {
                                      dense: "",
                                      text: "",
                                      type: "info",
                                      border: "left",
                                    },
                                  },
                                  [
                                    _vm._v(" Perfil de "),
                                    _c("strong", [_vm._v("administrador")]),
                                    _vm._v(": tem "),
                                    _c("strong", [
                                      _vm._v("todas as autorizações"),
                                    ]),
                                    _vm._v(". "),
                                  ]
                                )
                              : _c("part-role-permissions", {
                                  model: {
                                    value: _vm.model.permission,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "permission", $$v)
                                    },
                                    expression: "model.permission",
                                  },
                                }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.model.id
                  ? _c(
                      "v-tab-item",
                      [
                        _c(
                          "v-container",
                          { attrs: { fluid: "" } },
                          [
                            _vm.isAdminRole
                              ? _c(
                                  "v-alert",
                                  {
                                    attrs: {
                                      dense: "",
                                      text: "",
                                      type: "info",
                                      border: "left",
                                    },
                                  },
                                  [
                                    _vm._v(" Perfil de "),
                                    _c("strong", [_vm._v("administrador")]),
                                    _vm._v(": tem acesso a "),
                                    _c("strong", [
                                      _vm._v("todos os dashboards"),
                                    ]),
                                    _vm._v(". "),
                                  ]
                                )
                              : _c("part-role-charts", {
                                  model: {
                                    value: _vm.model.chart,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "chart", $$v)
                                    },
                                    expression: "model.chart",
                                  },
                                }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "v-tab-item",
                  [
                    _c("part-role-features", {
                      attrs: { role: _vm.model },
                      on: {
                        change: function ($event) {
                          _vm.featuresPayload = $event
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm.model.id
                  ? _c(
                      "v-tab-item",
                      [
                        _c(
                          "v-container",
                          { attrs: { fluid: "" } },
                          [
                            _c("part-role-users", {
                              attrs: { role: _vm.model },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c("emc-alert-snackbar", {
              attrs: {
                show: !!_vm.message.length,
                message: _vm.message,
                color: _vm.error ? "error" : "success",
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }